<script>
  import { onMount } from "svelte";
  import {
    selectedDeviceId,
    selectedPage,
    selectorAppId,
    selectorCarrier,
    selectorClient,
    selectorConfig,
    selectorDate,
    selectorDeviceId,
    selectorFirmware,
    selectorMobileId,
    selectorScript,
    tableData,
    uniqueAppIdValuesList,
    uniqueClientValuesList,
    uniqueConfigValuesList,
    uniqueFirmwareValuesList,
    uniqueMobileIdValuesList,
    uniqueScriptValuesList
  } from "../store";

  let disabled;

  selectorDeviceId.set([]);

  $: $tableData, switchEnable();

  function switchEnable() {
    disabled = $tableData.length == 0 ? true : false;
  }
</script>

<hr />

<h2 class="card-title">Selector</h2>

<hr />

<div class="row p-5">
  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Client</span>
      <select
        class="form-select"
        aria-label="Default select example"
        bind:value={$selectorClient}
      >
        <option selected />
        {#each $uniqueClientValuesList as client}
          <option value={client}>{client}</option>
        {/each}
      </select>
    </div>
  </div>

  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Config</span>
      <select
        class="form-select"
        aria-label="Default select example"
        bind:value={$selectorConfig}
      >
        <option selected />
        {#each $uniqueConfigValuesList as config}
          <option value={config}>{config}</option>
        {/each}
      </select>
    </div>
  </div>

  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Script</span>
      <select
        class="form-select"
        aria-label="Default select example"
        bind:value={$selectorScript}
      >
        <option selected />
        {#each $uniqueScriptValuesList as script}
          <option value={script}>{script}</option>
        {/each}
      </select>
    </div>
  </div>

  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Mobile ID</span>
      <select
        class="form-select"
        aria-label="Default select example"
        bind:value={$selectorMobileId}
      >
        <option selected />
        {#each $uniqueMobileIdValuesList as app_id}
          <option value={app_id}>{app_id}</option>
        {/each}
      </select>
    </div>
  </div>

  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">App ID</span>
      <select
        class="form-select"
        aria-label="Default select example"
        bind:value={$selectorAppId}
      >
        <option selected />
        {#each $uniqueAppIdValuesList as app_id}
          {#if app_id != null && app_id != "null"}
            <option value={app_id}>{app_id}</option>
          {/if}
        {/each}
      </select>
    </div>
  </div>

  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Firmware</span>
      <select
        class="form-select"
        aria-label="Default select example"
        bind:value={$selectorFirmware}
      >
        <option selected />

        {#each $uniqueFirmwareValuesList as fw}
          <option value={fw}>{fw}</option>
        {/each}
      </select>
    </div>
  </div>

  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Date</span>
      <input
        type="text"
        class="form-control"
        placeholder="dd/mm/yyyy"
        aria-describedby="basic-addon1"
        bind:value={$selectorDate}
      />
    </div>
  </div>

  <div class="col-md-6">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">Carrier</span>
      <select class="form-select" aria-label="Default select example" bind:value={$selectorCarrier}>
        <option selected />
        <option value={"Telcel"}>Telcel</option>
        <option value={"AT&T"}>AT&T</option>
      </select>
    </div>
  </div>
</div>

<div class="d-flex justify-content-end">
  <button
    {disabled}
    type="button"
    class="btn btn-primary"
    style="margin-right: 8px;"
    on:click={() => {
      selectedPage.set(3);
    }}><i class="bi bi-search" /> Search</button
  >
</div>

<br />

<style>
</style>
